import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_APP_BASE_URL, displayHostFromUrl } from 'src/utils/wrongDomain';

// Rendered from two very different runtimes: the Next.js interstitial page at
// pages/moved.jsx, and the React SPA bootstrap in src/index.js before the
// store, router, and theme providers have mounted. Styles are inline on
// purpose. The component cannot depend on a theme that has not been created
// yet, and it must not be exposed to the tss-react and MUI class ordering
// difference between local builds and Azure builds. A block page that renders
// unstyled in Production would be worse than a plain one.

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    backgroundColor: '#f4f6f8',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: '#263238',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: 560,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(38, 50, 56, 0.16)',
    padding: '40px 32px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  heading: {
    fontSize: 28,
    lineHeight: 1.25,
    fontWeight: 700,
    margin: '0 0 16px 0',
  },
  lead: {
    fontSize: 16,
    lineHeight: 1.5,
    margin: '0 0 20px 0',
    color: '#546e7a',
  },
  address: {
    fontSize: 24,
    lineHeight: 1.3,
    fontWeight: 700,
    wordBreak: 'break-word',
    margin: '0 0 28px 0',
    color: '#263238',
  },
  button: {
    display: 'inline-block',
    padding: '14px 28px',
    borderRadius: 8,
    backgroundColor: '#1976d2',
    color: '#ffffff',
    fontSize: 16,
    fontWeight: 600,
    textDecoration: 'none',
  },
  footnote: {
    fontSize: 14,
    lineHeight: 1.5,
    margin: '28px 0 0 0',
    color: '#546e7a',
  },
};

function WrongDomainNotice({
  continueUrl = DEFAULT_APP_BASE_URL,
  displayHost = displayHostFromUrl(DEFAULT_APP_BASE_URL),
}) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.heading}>Connection Point has moved</h1>
        <p style={styles.lead}>Sign in at this address:</p>
        <p style={styles.address}>{displayHost}</p>
        <a href={continueUrl} style={styles.button}>
          Continue to Connection Point
        </a>
        <p style={styles.footnote}>
          Please update your bookmark and share the correct address with your team.
        </p>
      </div>
    </div>
  );
}

WrongDomainNotice.propTypes = {
  continueUrl: PropTypes.string,
  displayHost: PropTypes.string,
};

export default WrongDomainNotice;
